import { SxProps, styled } from "@mui/material/styles";
import { rowFlexStyle } from "../../Common/styles/flex";

export const CBArea = styled("div")({
  height: "calc(100vh - 144px)",
  display: "flex",
  alignItems: "start",
  padding: "8px",
});

export const headerStyle: SxProps = {
  height: "80px",
  backgroundColor: "#ffffff",
  position: "sticky",
  top: 0,
  width: "100%",
  borderBottom: "1px solid",
  borderColor: "#E5E7EB",
  ...rowFlexStyle,
  alignItems: "center",
  px: 2.5,
};

export const CBMessageWrapper = styled("div")(() => ({
  height: "calc(100vh - 144px)",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const EmptyMessageWrapper = styled("div")(() => ({
  height: "100%",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const ConsentListStyle: SxProps = {
  flex: "1",
  height: "100%",
  px: 1,
  overflowY: "auto",
};

export const BlockItemStyle: SxProps = {
  width: "100%",

  boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.08)",

  py: 2,
  px: 2,
  border: 1,

  borderColor: "#E7E7E7",
  borderRadius: "12px",
  backgroundColor: "#FFFFFF",

  // "&:not(:last-child)": {
  marginBottom: 2.5,
  // },
};

export const BlockDescriptorStyle: SxProps = {
  background: "#ffffff",

  border: 1,
  borderColor: "#CFCFC9",
  borderRadius: 1,

  height: "40px",

  mr: 2,
  px: 1.5,
};

export const CBPickerWrapper = styled("div")({
  width: "278px",
  height: "100%",

  borderRadius: "4px",
  backgroundColor: "#ffffff",
  padding: "16px",
  overflowY: "hidden",

  "&:hover": {
    overflow: "auto",
  },
});
